import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { TAMANO_ICONO_CAMPANA_MODAL } from 'components/Maps/OutageDashboard/outageDashboard.constants';
import { TipoColorLineaAvanceEnum } from 'config';

const ModalStyles = makeStyles((theme: Theme) =>
  createStyles({
    caja: {
      borderRadius: '15px',
      position: 'fixed',
      width: '55vh',
      height: 'auto',
      minHeight: 'auto',
      maxHeight: '62vh',
      minWidth: '55vh',
      maxWidth: '55vh',
      color: 'black',
      background: '#FFFFFF;',
      zIndex: 7,
      marginLeft: '3.125rem',
      marginTop: '3vh',
      boxShadow: ' 0px 2px 20px rgba(9, 39, 84, 0.14)',
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        position: 'relative',
        marginLeft: '0vh',
        marginTop: '0vh',
        width: '100%',
        height: '100vh',
        minHeight: '100vh',
        maxHeight: '110vh',
        minWidth: '100%',
        maxWidth: 'auto',
        borderRadius: '0px',
        boxShadow: 'none',
      },
    },
    cajaImprevisto: {
      borderRadius: '20px',
      position: 'fixed',
      /**
       * Misma ancla que MapsStyles.buscadorCnt (top 112px / left 48px)
       */
      top: '112px',
      left: '48px',
      marginLeft: 0,
      marginTop: 0,
      width: 'min(1040px, calc(100vw - 96px))',
      height: 'auto',
      minHeight: 'min(560px, calc(100vh - 152px))',
      maxHeight: 'calc(100vh - 152px)',
      minWidth: 'min(720px, calc(100vw - 96px))',
      maxWidth: 'min(1040px, calc(100vw - 96px))',
      color: 'black',
      background: '#FFFFFF',
      zIndex: 7,
      boxShadow: '0px 2px 30px rgba(9, 39, 84, 0.14)',
      display: 'flex',
      flexDirection: 'column',
      overflowX: 'hidden',
      overflowY: 'hidden',
      overscrollBehavior: 'contain',
      paddingBottom: 0,
      paddingTop: 0,
      '&::-webkit-scrollbar': { width: '8px' },
      '&::-webkit-scrollbar-thumb': {
        background: '#D1D1D1',
        borderRadius: '40px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#EAEBF0',
        borderRadius: '40px',
      },
      /**
       * Bottom sheet mobile: hasta debajo del logo (mismo hueco que tracking)
       */
      [theme.breakpoints.down('sm')]: {
        position: 'fixed',
        top: 'auto',
        left: 0,
        right: 0,
        bottom: 0,
        marginLeft: 0,
        marginTop: 0,
        width: '100%',
        height: 'calc(100vh - 70px)',
        minHeight: 'calc(100vh - 70px)',
        maxHeight: 'calc(100vh - 70px)',
        minWidth: '100%',
        maxWidth: '100%',
        borderRadius: '20px 20px 0 0',
        boxShadow: '0px 2px 30px rgba(9, 39, 84, 0.14)',
        paddingTop: 0,
        zIndex: 8,
        overflowX: 'hidden',
        overflowY: 'hidden',
      },
    },
    /**
     * Desktop KML (sin tracking): el modal se ajusta al contenido, no a 560px
     */
    cajaImprevistoCompacto: {
      minHeight: 'auto',
      height: 'auto',
      [theme.breakpoints.down('sm')]: {
        height: 'calc(100vh - 70px)',
        minHeight: 'calc(100vh - 70px)',
        maxHeight: 'calc(100vh - 70px)',
      },
    },
    /**
     * Desktop sin gráfico clientes — 760px (Figma 9146:53427: 696 contenido + 64 padding)
     */
    cajaImprevistoSinGrafico: {
      width: 'min(760px, calc(100vw - 96px))',
      minWidth: 'min(760px, calc(100vw - 96px))',
      maxWidth: 'min(760px, calc(100vw - 96px))',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        minWidth: '100%',
        maxWidth: '100%',
      },
    },
    /**
     * Desktop: detalle 744px. Mobile: sheet más bajo que el dashboard (Figma 812−628 = 184px de mapa/logo)
     */
    cajaImprevistoDetalle: {
      width: 'min(744px, calc(100vw - 96px))',
      minWidth: 'min(744px, calc(100vw - 96px))',
      maxWidth: 'min(744px, calc(100vw - 96px))',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        minWidth: '100%',
        maxWidth: '100%',
        /**
         * Deja visible logo + mapa arriba (no subir hasta el tope como el dashboard)
         */
        height: 'calc(100vh - 184px)',
        minHeight: 'calc(100vh - 184px)',
        maxHeight: 'calc(100vh - 184px)',
      },
    },
    /**
     * Desktop corte futuro: el card llega al borde inferior del viewport.
     * El scroll queda en el contenido, no recorta la caja.
     */
    cajaImprevistoAjustado: {
      height: 'calc(100vh - 112px)',
      minHeight: 'calc(100vh - 112px)',
      maxHeight: 'calc(100vh - 112px)',
      [theme.breakpoints.down('sm')]: {
        height: 'calc(100vh - 70px)',
        minHeight: 'calc(100vh - 70px)',
        maxHeight: 'calc(100vh - 70px)',
      },
    },
    cajaIframe: {
      minHeight: '75vh !important',
      minWidth: '27% !important',
      [theme.breakpoints.down('sm')]: {
        minWidth: '100% !important',
      },
    },
    cuerpo: {
      overflowX: 'hidden',
      overflowY: 'auto',
      flex: '1 1 auto',
      minHeight: 0,
      '&::-webkit-scrollbar': { width: '8px' },
      '&::-webkit-scrollbar-thumb': {
        background: '#D1D1D1',
        borderRadius: '40px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#EAEBF0',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        borderBottomRightRadius: '15px',
        borderBottomLeftRadius: '15px',
      },

      '&::-webkit-scrollbar-button:decrement': {
        height: '0px',
        display: 'block',
        background: 'transparent',
        borderTopRightRadius: '100%',
        borderTopLeftRadius: '100%',
        paddingTop: '100px',
      },

      '&::-webkit-scrollbar-button:end:increment': {
        display: 'block',
        height: '20px',
        background: 'transparent',
        borderTopRightRadius: '100%',
        borderTopLeftRadius: '100%',
        borderBottomRightRadius: '100%',
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: '1vh',
        paddingBottom: '20vh',
        '&::-webkit-scrollbar': { display: 'none' },
      },
    },
    cuerpoImprevisto: {
      overflow: 'hidden',
      flex: '1 1 auto',
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
        paddingBottom: 0,
        overflow: 'hidden',
        flex: '1 1 auto',
        height: '100%',
        minHeight: 0,
      },
    },
    contenedorBoton: {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingTop: '15px',
      paddingRight: '8px',
    },
    contenedorBotonImprevistos: {
      /**
       * Desktop: right 54px (ajuste visual con padding content 37px).
       */
      position: 'absolute',
      top: 24,
      right: 54,
      zIndex: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      width: TAMANO_ICONO_CAMPANA_MODAL,
      height: TAMANO_ICONO_CAMPANA_MODAL,
      margin: 0,
      padding: 0,
      background: 'transparent',
      pointerEvents: 'none',
      /**
       * Mobile: absoluto respecto al sheet (el scroll vive en scrollArea, no en caja)
       */
      [theme.breakpoints.down('sm')]: {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        zIndex: 22,
        width: '100%',
        height: 0,
        margin: 0,
        padding: 0,
        paddingRight: 12,
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        overflow: 'visible',
        background: 'transparent',
        pointerEvents: 'none',
      },
    },
    botonCerrarImprevisto: {
      pointerEvents: 'auto',
      position: 'relative',
      padding: 0,
      margin: 0,
      width: TAMANO_ICONO_CAMPANA_MODAL,
      height: TAMANO_ICONO_CAMPANA_MODAL,
      minWidth: TAMANO_ICONO_CAMPANA_MODAL,
      minHeight: TAMANO_ICONO_CAMPANA_MODAL,
      borderRadius: 0,
      '&::after': {
        content: '""',
        position: 'absolute',
        top: -8,
        right: -8,
        bottom: -8,
        left: -8,
      },
      '& img': {
        display: 'block',
        width: TAMANO_ICONO_CAMPANA_MODAL,
        height: TAMANO_ICONO_CAMPANA_MODAL,
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: 16,
        marginRight: 4,
        padding: 4,
        width: 'auto',
        height: 'auto',
        minWidth: 'auto',
        minHeight: 'auto',
        backgroundColor: 'transparent',
        '&::after': {
          display: 'none',
        },
      },
    },
    /**
     * Mobile Detalle de avance: X a 24px del top (mismo padding del título)
     */
    botonCerrarImprevistoDetalle: {
      [theme.breakpoints.down('sm')]: {
        marginTop: 24,
      },
    },
    contenedorBotonMobile: {
      display: 'flex',
      paddingTop: '1.5rem',
      marginLeft: '1.5rem',
      marginBottom: '1.5rem',
    },

    botonCerrar: {
      backgroundColor: 'transparent',
      border: 'none',
      position: 'absolute',
      top: '1rem',
      right: '0.3rem',
    },

    cajaTitulo: {
      marginTop: '0rem',
      marginLeft: '1.5rem',
      display: 'flex',
      alignItems: 'center',
    },
    textoTitulo: {
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '18px',
    },
    textoTituloImprevisto: {
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '21px',
      lineHeight: '28px',
      color: 'var(--secundario-azul-marino)',
      marginTop: '20px',
      marginBottom: '32px',
    },
    textoParrafo: {
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontSize: '14px',
      paddingTop: '2px',
      lineHeight: '18px',
    },
    sizeSmall: {
      padding: '1px',
    },
    linea: {
      border: '1px solid #EAEBF0',
      marginLeft: '1.5rem',
      marginRight: '1.5rem',
      marginTop: '1.3rem',
    },
    circuloRojo: {
      display: 'flex',
      width: '13px',
      height: '13px',
      backgroundColor: 'red',
      borderRadius: '50%',
      marginRight: '15px',
    },

    circuloNaranja: {
      display: 'flex',
      width: '13px',
      height: '13px',
      backgroundColor: '#E08A00',
      borderRadius: '50%',
      marginRight: '15px',
    },
    circuloAzul: {
      display: 'flex',
      width: '13px',
      height: '13px',
      backgroundColor: TipoColorLineaAvanceEnum.FUTURO,
      borderRadius: '50%',
      marginRight: '15px',
    },
    circuloGris: {
      display: 'flex',
      width: '13px',
      height: '13px',
      backgroundColor: TipoColorLineaAvanceEnum.PENDIENTE,
      borderRadius: '50%',
      marginRight: '15px',
    },

    children: {
      marginBottom: '30px',
      alignItems: 'center',
      marginLeft: '20px',
      marginRight: '20px',
    },
    childrenImprevisto: {
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      paddingBottom: 0,
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      minHeight: 0,
      height: '100%',
      overflow: 'hidden',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        height: '100%',
        minHeight: 0,
        flex: '1 1 auto',
        overflow: 'hidden',
      },
    },
    tracking: {
      marginLeft: '3rem',
      marginRight: '1.5rem',
    },

    sinTracking: {
      alignItems: 'center',
      marginTop: '1rem',
      marginLeft: '1.1rem',
      marginRight: '1.1rem',
      backgroundColor: '#F4F4F4;',
      borderRadius: '10px',
      padding: '1.1rem',
      paddingBottom: '0.1rem',
    },

    cajaTextoNoTracking: {
      paddingBottom: '1rem',
    },

    contenedorMensaje: {
      marginTop: '1rem',
      marginLeft: '1.1rem',
      marginRight: '1.1rem',
      background: ' #F7F5FF',
      padding: '0.8rem',
      borderRadius: '0.5rem',
      display: 'flex',
      marginBottom: '2rem',

      [theme.breakpoints.down('sm')]: {
        width: 'auto',
        height: 'auto',
        marginBottom: '2rem',
      },
    },

    mensajeIcon: {
      '--icon-primary-dark': 'var(--primario-morado)',
      width: '1rem',
      height: '1rem',
      marginTop: '0.1rem',
      marginRight: '0.7rem',
      [theme.breakpoints.down('sm')]: {
        marginRight: '1rem',
      },
    },
    contenedorTextoIcono: {
      display: 'flex',
    },
    parrafo: {
      display: 'flex',
    },
  })
);

export default ModalStyles;
